/* LUMEJEY Original 1.0. No third party storefront runtime. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const cfg = JSON.parse($('#lj-config')?.textContent || '{}');
  const root = cfg.root || '/';
  const money = value => new Intl.NumberFormat(cfg.locale || 'es-ES', { style: 'currency', currency: cfg.currency || 'EUR' }).format(value / 100);
  const announce = text => { const status = $('#lj-status'); if (status) status.textContent = text; };
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const openDialog = dialog => {
    if (!dialog || dialog.open) return;
    $$('dialog[open]').forEach(d => d.close());
    dialog._returnFocus = document.activeElement;
    dialog.showModal();
    document.body.classList.add('lj-modal-open');
  };
  const showCartError = message => {
    const error = $('[data-cart-error]');
    if (error) { error.textContent = message; error.hidden = false; }
    announce(message);
  };
  async function request(url, options = {}) {
    const response = await fetch(url, { ...options, headers: { Accept: 'application/json', ...(options.headers || {}) } });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'No se ha podido completar la operación. Inténtalo de nuevo.');
    return data;
  }
  async function refreshCart() {
    const [cart, html] = await Promise.all([
      request(root + 'cart.js'),
      fetch(root + '?section_id=cart-panel').then(r => { if (!r.ok) throw new Error('No se puede actualizar el carrito.'); return r.text(); })
    ]);
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = $('[data-cart-content]', parsed);
    if (!content) throw new Error('No se puede mostrar el carrito. Puedes abrirlo desde el enlace Ver carrito completo.');
    $('[data-cart-content]').replaceChildren(...content.childNodes);
    $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const error = $('[data-cart-error]'); if (error) error.hidden = true;
    return cart;
  }
  let cartQueue = Promise.resolve();
  function changeCart(key, quantity) {
    cartQueue = cartQueue.catch(() => {}).then(async () => {
      const content = $('[data-cart-content]');
      content?.setAttribute('aria-busy', 'true');
      try {
        await request(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
        await refreshCart(); announce('Carrito actualizado.');
      } catch (error) { showCartError(error.message); }
      finally { $('[data-cart-content]')?.removeAttribute('aria-busy'); }
    });
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-dialog-open]');
    if (open) openDialog(document.getElementById(open.dataset.dialogOpen));
    const close = event.target.closest('[data-dialog-close]');
    if (close) close.closest('dialog')?.close();
    const cartLink = event.target.closest('[data-cart-open]');
    if (cartLink && document.body.dataset.cartDrawer === 'true' && $('#lj-cart')) {
      event.preventDefault(); openDialog($('#lj-cart')); refreshCart().catch(e => showCartError(e.message));
    }
    const remove = event.target.closest('[data-remove-key]');
    if (remove && remove.closest('#lj-cart')) { event.preventDefault(); changeCart(remove.dataset.removeKey, 0); }
    const step = event.target.closest('[data-quantity-step]');
    if (step) {
      const input = $('input', step.parentElement);
      try { Number(step.dataset.quantityStep) > 0 ? input.stepUp() : input.stepDown(); } catch (_) { return; }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const media = event.target.closest('[data-media-target]');
    if (media) {
      const target = $(`[data-media-id="${media.dataset.mediaTarget}"]`, media.closest('[data-product]'));
      target?.scrollIntoView({ block: 'nearest', inline: 'start', behavior: reduced.matches ? 'instant' : 'smooth' });
    }
    const jump = event.target.closest('[data-product-jump]');
    if (jump) {
      const target = document.querySelector('[data-product-form]');
      target?.scrollIntoView({ block: 'center', behavior: reduced.matches ? 'instant' : 'smooth' });
      target?.querySelector('[data-add-button]')?.focus({ preventScroll: true });
    }
    const cod = event.target.closest('[data-cod]');
    if (cod) {
      const scope = cod.closest('[data-product]');
      if (cfg.codSelector) {
        try {
          const target = $(cfg.codSelector);
          if (!target || target === cod || target.matches('[data-cod]')) throw new Error('No se encuentra el formulario contra reembolso. Contacta con LUMEJEY o usa el botón de compra principal.');
          target.click();
        } catch (error) { const el = $('[data-product-error]', scope); el.hidden = false; el.textContent = error.message; }
      } else { const form = $('[data-product-form]', scope); form._codCheckout = true; form.requestSubmit(); }
    }
  });
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-cart-key]');
    if (input && input.closest('#lj-cart') && input.validity.valid) changeCart(input.dataset.cartKey, Number(input.value));
    const pack = event.target.closest('[data-pack]');
    if (pack) { const scope = pack.closest('[data-product]'); const quantity = $('input[name="quantity"]', scope); if (quantity) { quantity.value = pack.value; quantity.dispatchEvent(new Event('change', { bubbles: true })); } }
    if (event.target.matches('input[name="quantity"]')) {
      const scope = event.target.closest('[data-product]');
      if (scope) $$('[data-pack]', scope).forEach(radio => radio.checked = radio.value === event.target.value);
    }
  });
  document.addEventListener('submit', async event => {
    const confirmText = event.target.dataset.confirm;
    if (confirmText && !window.confirm(confirmText)) { event.preventDefault(); return; }
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    const scope = form.closest('[data-product]');
    const errorEl = $('[data-product-error]', scope);
    const buttons = $$('[data-add-button],[data-cod],[data-sticky-button]', scope);
    const label = $('[data-button-label]', form);
    form.dataset.busy = 'true'; form.setAttribute('aria-busy', 'true'); errorEl.hidden = true;
    buttons.forEach(b => b.disabled = true); label.textContent = 'Un momento…';
    let added = false;
    try {
      const quantity = $('input[name="quantity"]', scope);
      if (quantity && (!quantity.validity.valid || Number(quantity.value) < 1)) throw new Error('Revisa la cantidad seleccionada.');
      const data = new FormData(form); if (!data.has('quantity')) data.set('quantity', '1');
      await request(root + 'cart/add.js', { method: 'POST', body: data }); added = true;
      announce('Producto añadido al carrito.');
      if (form._codCheckout || form.dataset.directCheckout === 'true') { window.location.assign(root + 'checkout'); return; }
      if (document.body.dataset.cartDrawer === 'true') {
        openDialog($('#lj-cart'));
        try { await refreshCart(); } catch (_) { window.location.assign(root + 'cart'); }
      } else window.location.assign(root + 'cart');
    } catch (error) { errorEl.textContent = (added ? 'El producto ya se ha añadido. ' : '') + error.message; errorEl.hidden = false; announce(errorEl.textContent); }
    finally {
      form._codCheckout = false; form.dataset.busy = 'false'; form.removeAttribute('aria-busy');
      const activeVariant = JSON.parse($('[data-variants]', scope).textContent).find(v => String(v.id) === $('[data-variant-select]', scope).value); buttons.forEach(b => b.disabled = !activeVariant?.available); label.textContent = activeVariant?.available ? ($('[data-add-button]', form).dataset.label || 'Añadir al carrito') : 'Agotado';
    }
  });
  function initProduct(scope) {
    if (scope.dataset.initialized) return; scope.dataset.initialized = 'true';
    const variants = JSON.parse($('[data-variants]', scope).textContent);
    const select = $('[data-variant-select]', scope);
    const form = $('[data-product-form]', scope);
    function updateVariant() {
      const variant = variants.find(v => String(v.id) === select.value); if (!variant) return;
      const price = $('[data-price]', scope);
      if (price) {
        price.replaceChildren(); const current = document.createElement('span'); current.textContent = money(variant.price); price.append(current);
        if (variant.compare_at_price > variant.price) { const old = document.createElement('s'); old.textContent = money(variant.compare_at_price); const badge = document.createElement('span'); badge.className = 'lj-badge'; badge.textContent = '-' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%'; price.append(old, badge); }
      }
      $$('[data-sticky-price]', scope).forEach(el => el.textContent = money(variant.price));
      $$('[data-add-button],[data-cod],[data-sticky-button]', scope).forEach(el => el.disabled = !variant.available);
      const button = $('[data-add-button]', scope); $('[data-button-label]', scope).textContent = variant.available ? button.dataset.label : 'Agotado';
      $$('[data-pack-price]', scope).forEach(el => el.textContent = money(variant.price * Number(el.dataset.packPrice)));
      const quantity = $('input[name="quantity"]', scope);
      if (quantity && variant.quantity_rule) {
        quantity.min = variant.quantity_rule.min || 1; quantity.step = variant.quantity_rule.increment || 1;
        if (variant.quantity_rule.max) quantity.max = variant.quantity_rule.max; else quantity.removeAttribute('max');
        if (!quantity.validity.valid) quantity.value = quantity.min;
      }
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      if (variant.featured_media?.id) $(`[data-media-id="${variant.featured_media.id}"]`, scope)?.scrollIntoView({ block: 'nearest', inline: 'start', behavior: reduced.matches ? 'instant' : 'smooth' });
      scope.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
    }
    select?.addEventListener('change', updateVariant);
    const sticky = $('[data-sticky-buy]', scope);
    if (sticky && form) {
      const observer = new IntersectionObserver(entries => {
        const show = !entries[0].isIntersecting && form.getBoundingClientRect().bottom < 0;
        sticky.hidden = !show; document.body.classList.toggle('lj-has-sticky', show);
      }, { threshold: 0 }); observer.observe(form); scope._stickyObserver = observer;
    }
  }
  function initCarousel(el) {
    if (el.dataset.initialized) return; el.dataset.initialized = 'true';
    const track = $('[data-slides]', el); const slides = $$('.lj-slide', el); if (!slides.length) return;
    let index = 0, timer, paused = false, hovered = false;
    const go = i => { index = (i + slides.length) % slides.length; track.scrollTo({ left: track.clientWidth * index, behavior: reduced.matches ? 'instant' : 'smooth' }); };
    $('[data-prev]', el)?.addEventListener('click', () => go(index - 1));
    $('[data-next]', el)?.addEventListener('click', () => go(index + 1));
    $$('[data-slide-to]', el).forEach(btn => btn.addEventListener('click', () => go(Number(btn.dataset.slideTo))));
    track.addEventListener('scroll', () => { index = Math.round(track.scrollLeft / track.clientWidth); $$('[data-slide-to]', el).forEach((b, i) => b.setAttribute('aria-current', String(i === index))); }, { passive: true });
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => { stop(); if (el.dataset.autoplay === 'true' && slides.length > 1 && !reduced.matches && !paused && !hovered && !el.contains(document.activeElement) && !document.hidden) timer = setInterval(() => go(index + 1), Number(el.dataset.interval) || 5000); };
    el.addEventListener('mouseenter', () => { hovered = true; stop(); }); el.addEventListener('mouseleave', () => { hovered = false; start(); });
    el.addEventListener('focusin', stop); el.addEventListener('focusout', () => setTimeout(start, 0));
    $('[data-pause]', el)?.addEventListener('click', event => { paused = !paused; event.currentTarget.textContent = paused ? 'Reanudar' : 'Pausar'; event.currentTarget.setAttribute('aria-pressed', String(paused)); start(); });
    document.addEventListener('visibilitychange', start); reduced.addEventListener('change', start); el._cleanup = () => { stop(); document.removeEventListener('visibilitychange', start); reduced.removeEventListener('change', start); }; start();
  }
  function initCountries(scope) {
    $$('[data-country-select]', scope).forEach(select => {
      if (select.dataset.initialized) return; select.dataset.initialized = 'true';
      const form = select.closest('form'); const province = $('[data-province-select]', form); const container = $('[data-province-container]', form);
      const choose = (el, value) => { const option = [...el.options].find(o => o.value === value || o.textContent === value); if (option) el.value = option.value; };
      choose(select, select.dataset.default);
      const update = () => { const pairs = JSON.parse(select.selectedOptions[0]?.dataset.provinces || '[]'); province.replaceChildren(); pairs.forEach(([value, title]) => { const o = new Option(title, value); province.add(o); }); container.hidden = pairs.length === 0; choose(province, province.dataset.default); };
      select.addEventListener('change', update); update();
    });
  }
  function init(scope = document) {
    $$('dialog', scope).forEach(dialog => {
      if (dialog.dataset.initialized) return; dialog.dataset.initialized = 'true';
      dialog.addEventListener('close', () => { if (!$('dialog[open]')) document.body.classList.remove('lj-modal-open'); dialog._returnFocus?.focus(); });
      dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
    });
    $$('[data-product]', scope).forEach(initProduct); $$('[data-carousel]', scope).forEach(initCarousel);
    $$('[data-comparison]', scope).forEach(el => { if (el.dataset.initialized) return; el.dataset.initialized = 'true'; $('input', el).addEventListener('input', e => { el.style.setProperty('--reveal', e.target.value + '%'); e.target.setAttribute('aria-valuetext', e.target.value + ' por ciento de la imagen anterior'); }); });
    $$('[data-recommendations]', scope).forEach(el => { if (el.dataset.initialized || el.querySelector('.lj-product-card')) return; el.dataset.initialized = 'true'; fetch(el.dataset.url).then(r => r.text()).then(html => { if (!el.isConnected) return; const next = $('[data-recommendations]', new DOMParser().parseFromString(html, 'text/html')); if (next?.querySelector('.lj-product-card')) el.innerHTML = next.innerHTML; }).catch(() => {}); });
    initCountries(scope);
  }
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => { $$('[data-product]', e.target).forEach(el => el._stickyObserver?.disconnect()); $$('[data-carousel]', e.target).forEach(el => el._cleanup?.()); document.body.classList.remove('lj-has-sticky'); });
  document.addEventListener('shopify:block:select', e => { const slide = e.target.closest('.lj-slide'); if (slide) slide.scrollIntoView({ block: 'nearest', inline: 'start' }); });
  init();
})();
